import { render, staticRenderFns } from "./tech-layout.vue?vue&type=template&id=711fc1cb&scoped=true"
import script from "./tech-layout.vue?vue&type=script&lang=ts"
export * from "./tech-layout.vue?vue&type=script&lang=ts"
import style0 from "./tech-layout.vue?vue&type=style&index=0&id=711fc1cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711fc1cb",
  null
  
)

export default component.exports